import React from "react";
import { Row, Col } from "antd";
import BookRecommend from '../component/BookRecommend'
import YourRecommend from '../component/YourRecommend'

const App = () => {
    return (<>
        <Row justify={'center'} gutter={[0,20]}>
            <Col span={24} />
            <Col span={23}>
                <BookRecommend />
            </Col>
            <Col span={23}>
                <YourRecommend/>
            </Col>
        </Row>
    </>)
}

export default App